import { ClientTable } from 'vue-tables-2';
import ServerTable from './vuetable2-checkbox/v-server-table';
import Vue from 'vue';
import options from './vuetable-options';

Vue.use(
    ClientTable,
    options,
    false,
    'bootstrap4',
    require('../plugins/vuetable2-checkbox/template.jsx'),
);

Vue.use(
    ServerTable,
    options,
    true,
    'bootstrap4',
    require('../plugins/vuetable2-checkbox/template.jsx'),
);
